import * as React from 'react';
import { Form, Table } from '../../components';
import ApiService from '../../services/api.service';
import AppService from '../../services/app.service';

interface IProps {
  history?: any;
  id?: any;
  caption?: string;
  captionColor?: any;
  captionThin?: boolean;
  nodataCaption ?: string;
  endPointFilter?: string;
  model: any;
  header?: any;
  currentId?: any;
  onLoad?: (data: any) => void;
  onLoadAll?: (data: any, page?: any) => any;
  page?: number;
  pageSize?: number;
  searchField?: string;
  onChangePage?: (value: number) => void;
  selectedOnly?: boolean;
  readOnly?: boolean;
  cardColor?: any;
  cardGradientColor?: any;
  disableBackButton?: boolean;
  disableCard?: boolean;
  disableView?: boolean;
}

interface IState {
  dataset: Array<any>;
  header: Array<any>;
  endPointFilter: string;
  page: number;
  pageSize: number;
  pageCount: number;
  pageName: string;
  filter: string;
  searchText: string;
  isSearch: boolean;
  isReady: boolean;
  isError: boolean;
}

export default class BaseCheckList extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      dataset: [],
      header: this.header(),
      endPointFilter: this.props.endPointFilter || '',
      page: this.props.page || 1,
      pageSize: this.props.pageSize || 10,
      pageCount: 0,
      pageName: this.props.model.url.replace('/','') + (this.props.id || '') + 'Page',
      filter: '',
      searchText: '',
      isSearch: this.props.model.columnPicklist.findIndex((d: { name: string; }) => d.name === (this.props.searchField || 'name'))>=0,
      isReady: false,
      isError: false,
    }
    
    this.onChangePage = this.onChangePage.bind(this);
    this.onChangeSearch = this.onChangeSearch.bind(this);
    this.onClickSearch = this.onClickSearch.bind(this);
    this.onEndTypingSearch = this.onEndTypingSearch.bind(this);
  }
  
  private historyState: any = this.props.history?.location.state;
  private isLoading: boolean = false;
  
  private header() {
    return this.props.header || this.props.model.columnPicklist;
  }

  private loadData (page: number, searchText?: string, filter?: string) {
    if (this.isLoading) return;
    this.isLoading = true;
    this.setState({ isReady: false});
    
    const paginationPage = '&pagination[page]=' + page;
    const paginationPageSize = '&pagination[pageSize]=' + this.state.pageSize;
    const search = searchText? '&filters[' + (this.props.searchField || 'name') + '][$contains]=' + searchText : paginationPage;
    ApiService.getAll<typeof this.props.model>(this.props.model.endPoint + (this.props.endPointFilter || '?populate=*') + filter + search + paginationPageSize)
    .then(rp => {
      if (rp.Status) {
        const pageCount = Math.ceil((rp.Meta?.pagination?.total || 1) / this.state.pageSize);
        var dataset = rp.Data?.map((d: any) => new this.props.model(d));        
        if (this.state.pageSize === 1) this.props.onLoad?.(dataset[0]);
        var loadAll = this.props.onLoadAll?.(dataset, rp.Meta.pagination);
        this.setState({ dataset: loadAll?.dataset || dataset, pageCount: pageCount, pageSize: loadAll?.pageSize || this.state.pageSize, isReady: true });

      } 
      else { this.setState({ isReady: true, isError: true }); }
      this.isLoading = false;
    });
  }

  private onChangePage (value: number) {
    AppService.historyState(this.state.pageName, value);
    this.setState({page: value});
    this.loadData(value, this.state.searchText, this.state.filter);
    this.props.onChangePage?.(value)
  }
  
  private onChangeSearch (fieldName: string, value?: string) { 
    this.setState({searchText: value || ''});
    if (!value) this.loadData(this.state.page, value);
  }
  
  private onClickSearch() { 
    this.loadData(this.state.page, this.state.searchText, this.state.filter);
  }

  private onEndTypingSearch(fieldName?: string, value?: string) {
    this.setState({searchText: value || ''});
    this.loadData(this.state.page, value);
  }

  private currentIds() {
    if (this.props.readOnly || this.props.selectedOnly){
      if (!this.props.currentId || this.props.currentId.length === 0)
        return '&filters[id][$in]=0'
      else 
        return this.props.currentId?.map((d: any) =>  '&filters[id][$in]=' + d.id );
    }
    else return '';
  }

  private table(){
    return <Table header={this.state.header} dataset={this.state.dataset} currentId={this.props.currentId} nodataCaption ={this.props.nodataCaption } page={this.state.page} pageCount={this.state.pageCount} maxHeight={200} searchText={this.state.searchText} isSearch={this.state.isSearch} isLoading={this.isLoading} isReady={this.state.isReady} isError={this.state.isError} onChangePage={this.onChangePage} onChangeSearch={this.onChangeSearch} onClickSearch={this.onClickSearch} onEndTypingSearch={this.onEndTypingSearch} onLoad={this.props.onLoad} readOnly={this.props.readOnly} checklistView/>
  }

  public componentDidMount() {
    const page = this.historyState?.[this.state.pageName] || this.state.page;
    const filter = this.currentIds();
    this.loadData(page, '', filter);
    this.setState({page: page, filter: filter});
  }
  
  public componentDidUpdate() {
    if (this.header() !== this.state.header)
      this.setState({ header: this.header()});

    if (!this.isLoading)
      if (this.props.page && (this.props.page !== this.state.page)) {
        const filter = this.currentIds();
        this.loadData(this.props.page, '', filter);
        this.setState({page: this.props.page, filter: filter});
      }
      else if (this.props.endPointFilter && (this.props.endPointFilter !== this.state.endPointFilter)) {
        this.setState({endPointFilter: this.props.endPointFilter})
        this.loadData(1);
    }
  }

  public render(): React.ReactNode {    
    const caption = this.props.caption || 'Select' + (this.props.readOnly? 'ed ': ' ') +  AppService.strPluralize(this.props.model.caption);
   
    return (
      <Form history={this.props.history} caption={caption} captionColor={this.props.captionColor} captionThin={this.props.captionThin} buttonCaption=' ' cardColor={this.props.cardColor} cardGradientColor={this.props.cardGradientColor} disableBackButton={this.props.disableBackButton} disableCard={this.props.disableCard}>              
          {!this.props.disableView && this.table()}
      </Form> 
    );
  }
}
